import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import Bus from './plugins/bus'
import VuePlugins from './plugins'
import Request from './utils/request'
import './assets/sass/app.scss'

// Sync router to store
sync(store, router)

Vue.config.productionTip = false
Vue.config.silent = process.env.NODE_ENV !== 'development'
Vue.config.productionTip = process.env.NODE_ENV !== 'production'
Vue.use(Bus)

Vue.use(VuePlugins)

Request.init()

const app = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')

export default app
